import YYImage from "@/pages/design/components/basic/image";
import YYTag from "@/pages/design/components/basic/tag";
import YYButton from "@/pages/design/components/basic/button";
import YYMessage from '@/pages/design/components/basic/message';
// import { deleteCollect } from '@/api/memberCenter';

import _style from '@/theme/css/common/color.scss';
import i18n from '@/pages/design/locales';
export default {
  name: "productItem",
  components: {
    YYImage: YYImage,
    YYTag: YYTag,
    YYButton: YYButton,
    YYMessage: YYMessage
  },
  props: {
    productDetail: {},
    type: {},
    addCartBgColor: {
      type: String,
      default: _style.color_white
    }
  },
  data: function data() {
    return {
      rightCurrencySymbol: window.localStorage.getItem('rightCurrencySymbol'),
      leftCurrencySymbol: window.localStorage.getItem('leftCurrencySymbol'),
      // rightCurrencySymbol: '',
      // leftCurrencySymbol: '',
      //提交锁
      submitLock: false,
      i18n: i18n
    };
  },
  computed: {
    style: function style() {
      return _style;
    },
    showShadow: function showShadow() {
      //是否显示遮罩
      return this.productDetail.productStockNum <= 0 || this.productDetail.productStatus == 0 || this.productDetail.productStatus == 2;
    }
  },
  created: function created() {
    var lang = localStorage.langCode;
    this.i18n.locale = lang;
    this.$t = this.i18n.t.bind(this.i18n);
    // this.$t.bind(this.i18n)
  },
  methods: {
    addCart: function addCart(productNo) {
      var self = this;
      if (this.submitLock) {
        return;
      } else {
        this.submitLock = true;
      }
      // this.$addCart(productNo,1,(res)=>{
      // 	if(res.data.code == 200){
      // 		YYMessage(this.$t('addCartSuccess'))
      // 		this.$emit("addCartHandle")
      // 		self.shopcartNum = self.$store.state.shopcartNum;
      // 		// this.$getShopcartNum((res)=>{
      // 		// 	if(res.data.code == 200){
      // 		// 		self.$store.state.shopcartNum = res.data.data.productNumber;
      // 		// 		self.shopcartNum = self.$store.state.shopcartNum;
      // 		// 	}
      // 		// })
      // 	}
      // }).finally(()=>{
      // 	this.submitLock = false;
      // })
    },
    deleteCollect: function deleteCollect(id) {
      var self = this;
      // deleteCollect(id).then(res => {
      // 	if (res.data.code == 200) {
      // 		self.$parent.loadData();
      // 		YYMessage(self.$t('myOrder.orderCancelSuccess'));
      // 	}
      // });
    }
  }
};